<section [class]="body.primary.pink_background ? 'gradient my-5 my-lg-6' : ''">
    <div class="container py-5 py-lg-6">
        <div [class]="body.primary.pink_background ? 'px-3 py-5 p-xl-5 py-xl-6' : ''" appAos>
            <div class="row d-flex align-items-center">
                <div class="col-xl-7" [class.order-xl-1]="body?.primary?.media_right || body.primary.pink_background">
                    @if (body.primary.video) {
                    <video class="w-100 rounded-4" controls [poster]="body.primary.thumbnail?.url">
                        <source [src]="'/assets/videos/' + body.primary.video" type="video/mp4" />
                    </video>
                    } @else {
                    <img [src]="body.primary.thumbnail?.url" [alt]="body.primary.thumbnail?.alt" class="w-100 rounded-4" />
                    }
                </div>
                <div
                    class="col-xl mt-5 mt-xl-0"
                    [class.order-xl-0]="body?.primary?.media_right || body.primary.pink_background"
                    [class.pe-xl-5]="body?.primary?.media_right || body.primary.pink_background"
                    [class.ps-xl-5]="!body?.primary?.media_right && !body.primary.pink_background"
                >
                    <p class="heading" [class.text-white]="body?.primary.pink_background">
                        {{ body.primary.heading }}
                    </p>
                    <div [innerHTML]="body?.primary.title | renderHtml : htmlSerializer"></div>
                    <div [innerHTML]="body?.primary.description | renderHtml"></div>
                    <div class="row justify-content-between align-items-center mt-5">
                        <div class="col-md-auto order-md-1 mb-4 mb-lg-0">
                            @if (body?.primary?.logo?.url) {
                            <img [src]="body?.primary?.logo?.url" [alt]="body?.primary?.logo?.alt" class="icon-big" />
                            }
                        </div>

                        <div class="col-md order-md-0">
                            <app-link
                                [link]="body?.primary.button_link"
                                [cssClass]="'btn btn-black'"
                                [action]="body?.primary.button_action"
                            >
                                {{ body?.primary.button_title }}
                            </app-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
